// Copyright (c) Docugami, Inc. All rights reserved.

import { Dropdown, IDropdownOption, IIconProps } from "@fluentui/react";
import { ExplorerStatusItemLabel } from "components/common/Fonts";
import { homeGray } from "components/shell/presentation/AppStyles";
import styled from "styled-components";

const PlaceholderTextRoot = styled(ExplorerStatusItemLabel)`
    color: ${homeGray};
`;

const OptionsText = styled(ExplorerStatusItemLabel)`
    font-weight: 700;
`;

export type IFilterOption = IDropdownOption<{
    icon?: IIconProps
}>

interface CommandBarDropdownProps {
    label: string;
    options: IFilterOption[];
    onChange: (ev: React.FormEvent<HTMLDivElement>, option: IFilterOption | undefined) => void;
    onRenderOption?: (option?: IFilterOption, defaultRender?: (props?: IFilterOption) => JSX.Element | null) => JSX.Element | null;
    multiSelect?: boolean;
}

export const CommandBarDropdown = (props: CommandBarDropdownProps) => {
    return (
        <Dropdown
            styles={{
                root: { display: 'flex' },
                title: {
                    background: 'inherit',
                    border: 'none'
                },
            }}
            dropdownWidth={'auto'}
            placeholder={props.label}
            multiSelect={props.multiSelect}
            options={props.options}
            onChange={props.onChange}
            onRenderPlaceholder={(props, defaultRender) => <PlaceholderTextRoot>{defaultRender?.(props)}</PlaceholderTextRoot>}
            onRenderTitle={(props) => !props ? null : <OptionsText title={props?.map(x => x.text).toLocaleString()}>{props[0].text}{props.length > 1 ? ` (+${props.length - 1})` : ''}</OptionsText>}
            onRenderOption={props.onRenderOption} />
    )
}